/*
  Le catalogue du selecteur d'emojis, et de quoi les chercher.

  Engendre depuis les tables Unicode : les plages sont choisies, le reste
  suit, et ce qui n'est pas attribue ou ne se pose pas seul est ecarte.

  Chaque emoji porte des mots pour le trouver. Ils viennent de son nom
  Unicode, traduit mot a mot par un petit dictionnaire — les noms sont
  tres repetitifs, une centaine de mots en couvrent la plus grande part.
  Ce que le dictionnaire ne connait pas reste en anglais : « pizza »,
  « taxi » ou « panda » se cherchent pareil dans les deux langues, et un
  mot de trop ne gene personne.

  Le nom Unicode anglais suit, mot pour mot : l'application parle aussi
  anglais, et « heart » doit trouver le coeur comme « coeur ».
*/
import { t } from '../i18n';


export interface FamilleEmoji {
  nom: string;
  /** Le signe qui represente la famille. */
  onglet: string;
  /** Le signe, puis les mots qui le trouvent. */
  signes: Array<[string, string]>;
}

export const FAMILLES_EMOJI: FamilleEmoji[] = [
  {
    nom: t.composants.emojis.smileys,
    onglet: '😀',
    signes: [
      ['😀', 'sourire rire visage tete grinning face'],
      ['😁', 'sourire rire visage tete souriant content yeux grinning face smiling eyes'],
      ['😂', 'visage tete larmes pleure joie rire face tears joy'],
      ['😃', 'sourire souriant content visage tete ouvert bouche smiling face open mouth'],
      ['😄', 'sourire souriant content visage tete ouvert bouche yeux smiling face open mouth eyes'],
      ['😅', 'sourire souriant content visage tete ouvert bouche cold sueur transpire smiling face open mouth sweat'],
      ['😆', 'sourire souriant content visage tete ouvert bouche tightly ferme yeux smiling face open mouth tightly-closed eyes'],
      ['😇', 'sourire souriant content visage tete aureole smiling face halo'],
      ['😈', 'sourire souriant content visage tete horns smiling face'],
      ['😉', 'clin oeil visage tete winking face'],
      ['😊', 'sourire souriant content visage tete yeux smiling face eyes'],
      ['😋', 'visage tete savouring delicious food face'],
      ['😌', 'relieved visage tete face'],
      ['😍', 'sourire souriant content visage tete coeur shaped yeux smiling face heart-shaped eyes'],
      ['😎', 'sourire souriant content visage tete lunettes soleil smiling face sunglasses'],
      ['😏', 'malicieux visage tete smirking face'],
      ['😐', 'neutre visage tete neutral face'],
      ['😑', 'blase visage tete expressionless face'],
      ['😒', 'blase agace visage tete unamused face'],
      ['😓', 'visage tete cold sueur transpire face sweat'],
      ['😔', 'pensif triste visage tete pensive face'],
      ['😕', 'perplexe visage tete confused face'],
      ['😖', 'confus visage tete confounded face'],
      ['😗', 'bisou embrasse visage tete kissing face'],
      ['😘', 'visage tete throwing a bisou bise embrasse face kiss'],
      ['😙', 'bisou embrasse visage tete sourire souriant content yeux kissing face smiling eyes'],
      ['😚', 'bisou embrasse visage tete ferme yeux kissing face closed eyes'],
      ['😛', 'visage tete stuck out langue face stuck-out tongue'],
      ['😜', 'visage tete stuck out langue clin oeil face stuck-out tongue winking eye'],
      ['😝', 'visage tete stuck out langue tightly ferme yeux face stuck-out tongue tightly-closed eyes'],
      ['😞', 'decu visage tete disappointed face'],
      ['😟', 'inquiet visage tete worried face'],
      ['😠', 'colere enerve fache visage tete angry face'],
      ['😡', 'colere fache visage tete pouting face'],
      ['😢', 'pleure larme visage tete crying face'],
      ['😣', 'perseverant visage tete persevering face'],
      ['😤', 'visage tete look triumph face'],
      ['😥', 'decu but relieved visage tete disappointed face'],
      ['😦', 'frowning visage tete ouvert bouche face open mouth'],
      ['😧', 'anguished visage tete face'],
      ['😨', 'peur visage tete fearful face'],
      ['😩', 'epuise visage tete weary face'],
      ['😪', 'endormi somnole visage tete sleepy face'],
      ['😫', 'fatigue visage tete tired face'],
      ['😬', 'grimace visage tete grimacing face'],
      ['😭', 'fort pleure larme visage tete loudly crying face'],
      ['😮', 'visage tete ouvert bouche face open mouth'],
      ['😯', 'surpris visage tete hushed face'],
      ['😰', 'visage tete ouvert bouche cold sueur transpire face open mouth sweat'],
      ['😱', 'visage tete cri in fear face screaming'],
      ['😲', 'etonne surpris visage tete astonished face'],
      ['😳', 'gene rouge visage tete flushed face'],
      ['😴', 'dort dormir visage tete sleeping face'],
      ['😵', 'etourdi visage tete dizzy face'],
      ['😶', 'visage tete without bouche face mouth'],
      ['😷', 'visage tete medical masque malade face mask'],
      ['😸', 'sourire rire chat visage tete souriant content yeux grinning cat face smiling eyes'],
      ['😹', 'chat visage tete larmes pleure joie rire cat face tears joy'],
      ['😺', 'sourire souriant content chat visage tete ouvert bouche smiling cat face open mouth'],
      ['😻', 'sourire souriant content chat visage tete coeur shaped yeux smiling cat face heart-shaped eyes'],
      ['😼', 'chat visage tete wry sourire cat face smile'],
      ['😽', 'bisou embrasse chat visage tete ferme yeux kissing cat face closed eyes'],
      ['😾', 'colere fache chat visage tete pouting cat face'],
      ['😿', 'pleure larme chat visage tete crying cat face'],
      ['🙀', 'epuise chat visage tete weary cat face'],
      ['🙁', 'slightly frowning visage tete face'],
      ['🙂', 'slightly sourire souriant content visage tete smiling face'],
      ['🙃', 'upside bas visage tete upside-down face'],
      ['🙄', 'visage tete rolling yeux face eyes'],
      ['🙅', 'visage tete no good gesture face'],
      ['🙆', 'visage tete ok gesture face'],
      ['🙇', 'person bowing deeply'],
      ['🙈', 'see no evil singe see-no-evil monkey'],
      ['🙉', 'hear no evil singe hear-no-evil monkey'],
      ['🙊', 'speak no evil singe speak-no-evil monkey'],
      ['🙋', 'happy person raising one main hand'],
      ['🙌', 'person raising both mains in celebration hands'],
      ['🙍', 'person frowning'],
      ['🙎', 'person colere fache visage tete pouting face'],
      ['🙏', 'person priere merci mains folded hands'],
      ['🤐', 'zipper bouche visage tete zipper-mouth face'],
      ['🤑', 'argent bouche visage tete money-mouth face'],
      ['🤒', 'visage tete thermometer face'],
      ['🤓', 'intello visage tete nerd face'],
      ['🤔', 'reflechit pense visage tete thinking face'],
      ['🤕', 'visage tete head bandage face head-bandage'],
      ['🤖', 'robot visage tete face'],
      ['🤗', 'calin visage tete hugging face'],
      ['🤘', 'signe horns'],
      ['🤙', 'call me main hand'],
      ['🤚', 'leve back main raised hand'],
      ['🤛', 'gauche facing poing left-facing fist'],
      ['🤜', 'droite facing poing right-facing fist'],
      ['🤝', 'handshake'],
      ['🤞', 'main index milieu doigts crossed hand middle fingers'],
      ['🤟', 'i amour you main signe love hand'],
      ['🤠', 'visage tete cowboy hat face'],
      ['🤡', 'clown visage tete face'],
      ['🤢', 'nauseated visage tete face'],
      ['🤣', 'rolling on floor laughing'],
      ['🤤', 'drooling visage tete face'],
      ['🤥', 'menteur visage tete lying face'],
      ['🤦', 'visage tete palm face'],
      ['🤧', 'sneezing visage tete face'],
      ['🤨', 'visage tete one eyebrow leve face raised'],
      ['🤩', 'sourire rire visage tete etoile yeux grinning face star eyes'],
      ['🤪', 'sourire rire visage tete one large small oeil grinning face eye'],
      ['🤫', 'visage tete doigt covering ferme lips face finger closed'],
      ['🤬', 'serious visage tete symbols covering bouche face mouth'],
      ['🤭', 'sourire souriant content visage tete yeux main covering bouche smiling face eyes hand mouth'],
      ['🤮', 'visage tete ouvert bouche vomiting face open mouth'],
      ['🤯', 'shocked visage tete exploding head face'],
      ['🥰', 'sourire souriant content visage tete yeux three coeurs smiling face eyes hearts'],
      ['🥱', 'yawning visage tete face'],
      ['🥲', 'sourire souriant content visage tete tear smiling face'],
      ['🥳', 'visage tete fete horn hat face party'],
      ['🥴', 'visage tete uneven yeux wavy bouche face eyes mouth'],
      ['🥵', 'overheated visage tete face'],
      ['🥶', 'freezing visage tete face'],
      ['🥷', 'ninja'],
      ['🥸', 'disguised visage tete face'],
      ['🥹', 'visage tete holding back larmes pleure face tears'],
      ['🥺', 'visage tete pleading yeux face eyes'],
      ['🧐', 'visage tete monocle face'],
    ],
  },
  {
    nom: t.composants.emojis.gestes,
    onglet: '👍',
    signes: [
      ['👊', 'fisted main signe hand'],
      ['👋', 'salut coucou main signe waving hand'],
      ['👌', 'ok main signe hand'],
      ['👍', 'pouce haut signe thumbs up'],
      ['👎', 'pouce bas signe thumbs down'],
      ['👏', 'applaudit bravo mains signe clapping hands'],
      ['👐', 'ouvert mains signe open hands'],
      ['🖐', 'leve main doigts splayed raised hand fingers'],
      ['🖖', 'leve main part between milieu bague doigts raised hand middle ring fingers'],
      ['🤘', 'signe horns'],
      ['🤙', 'call me main hand'],
      ['🤚', 'leve back main raised hand'],
      ['🤛', 'gauche facing poing left-facing fist'],
      ['🤜', 'droite facing poing right-facing fist'],
      ['🤝', 'handshake'],
      ['🤞', 'main index milieu doigts crossed hand middle fingers'],
      ['🤟', 'i amour you main signe love hand'],
      ['🤲', 'palms haut together up'],
      ['🤳', 'selfie'],
      ['✊', 'leve poing raised fist'],
      ['✋', 'leve main raised hand'],
      ['✌', 'victoire paix main victory hand'],
      ['✍', 'ecrit main writing hand'],
    ],
  },
  {
    nom: t.composants.emojis.coeurs,
    onglet: '❤️',
    signes: [
      ['💓', 'beating coeur heart'],
      ['💔', 'broken coeur heart'],
      ['💕', 'two coeurs hearts'],
      ['💖', 'sparkling coeur heart'],
      ['💗', 'growing coeur heart'],
      ['💘', 'coeur arrow heart'],
      ['💙', 'blue coeur heart'],
      ['💚', 'green coeur heart'],
      ['💛', 'yellow coeur heart'],
      ['💜', 'purple coeur heart'],
      ['💝', 'coeur ribbon heart'],
      ['💞', 'revolving coeurs hearts'],
      ['💟', 'coeur decoration heart'],
      ['🖤', 'black coeur heart'],
      ['🤍', 'white coeur heart'],
      ['🤎', 'brown coeur heart'],
      ['🤏', 'pinching main hand'],
      ['🧡', 'orange coeur heart'],
    ],
  },
  {
    nom: t.composants.emojis.animaux,
    onglet: '🐶',
    signes: [
      ['🐀', 'rat'],
      ['🐁', 'souris mouse'],
      ['🐂', 'ox'],
      ['🐃', 'eau buffalo water'],
      ['🐄', 'vache cow'],
      ['🐅', 'tigre tiger'],
      ['🐆', 'leopard'],
      ['🐇', 'lapin rabbit'],
      ['🐈', 'chat cat'],
      ['🐉', 'dragon'],
      ['🐊', 'crocodile'],
      ['🐋', 'baleine whale'],
      ['🐌', 'escargot snail'],
      ['🐍', 'serpent snake'],
      ['🐎', 'cheval horse'],
      ['🐏', 'ram'],
      ['🐐', 'chevre goat'],
      ['🐑', 'mouton sheep'],
      ['🐒', 'singe monkey'],
      ['🐓', 'rooster'],
      ['🐔', 'poule poulet chicken'],
      ['🐕', 'chien dog'],
      ['🐖', 'cochon pig'],
      ['🐗', 'sanglier boar'],
      ['🐘', 'elephant'],
      ['🐙', 'pieuvre octopus'],
      ['🐚', 'spiral coquillage shell'],
      ['🐛', 'insecte bug'],
      ['🐜', 'fourmi ant'],
      ['🐝', 'honeybee'],
      ['🐞', 'lady beetle'],
      ['🐟', 'poisson fish'],
      ['🐠', 'tropical poisson fish'],
      ['🐡', 'blowfish'],
      ['🐢', 'tortue turtle'],
      ['🐣', 'hatching chick'],
      ['🐤', 'baby chick'],
      ['🐥', 'front facing baby chick front-facing'],
      ['🐦', 'oiseau bird'],
      ['🐧', 'pingouin penguin'],
      ['🐨', 'koala'],
      ['🐩', 'poodle'],
      ['🐪', 'dromedary chameau camel'],
      ['🐫', 'bactrian chameau camel'],
      ['🐬', 'dauphin dolphin'],
      ['🐭', 'souris visage tete mouse face'],
      ['🐮', 'vache visage tete cow face'],
      ['🐯', 'tigre visage tete tiger face'],
      ['🐰', 'lapin visage tete rabbit face'],
      ['🐱', 'chat visage tete cat face'],
      ['🐲', 'dragon visage tete face'],
      ['🐳', 'spouting baleine whale'],
      ['🐴', 'cheval visage tete horse face'],
      ['🐵', 'singe visage tete monkey face'],
      ['🐶', 'chien visage tete dog face'],
      ['🐷', 'cochon visage tete pig face'],
      ['🐸', 'grenouille visage tete frog face'],
      ['🐹', 'hamster visage tete face'],
      ['🐺', 'loup visage tete wolf face'],
      ['🐻', 'ours visage tete bear face'],
      ['🐼', 'panda visage tete face'],
      ['🐽', 'cochon nose pig'],
      ['🐾', 'paw prints'],
      ['🐿', 'chipmunk'],
      ['🦀', 'crabe crab'],
      ['🦁', 'lion visage tete face'],
      ['🦂', 'scorpion'],
      ['🦃', 'turkey'],
      ['🦄', 'licorne visage tete unicorn face'],
      ['🦅', 'aigle eagle'],
      ['🦆', 'canard duck'],
      ['🦇', 'chauve souris bat'],
      ['🦈', 'requin shark'],
      ['🦉', 'hibou owl'],
      ['🦊', 'renard visage tete fox face'],
      ['🦋', 'papillon butterfly'],
      ['🦌', 'cerf deer'],
      ['🦍', 'gorilla'],
      ['🦎', 'lezard lizard'],
      ['🦏', 'rhinoceros'],
      ['🦐', 'crevette shrimp'],
      ['🦑', 'calamar squid'],
      ['🦒', 'girafe visage tete giraffe face'],
      ['🦓', 'zebra visage tete face'],
      ['🦔', 'hedgehog'],
      ['🦕', 'sauropod'],
      ['🦖', 't rex t-rex'],
      ['🦗', 'cricket'],
      ['🦘', 'kangaroo'],
      ['🦙', 'llama'],
      ['🦚', 'peacock'],
      ['🦛', 'hippopotamus'],
      ['🦜', 'parrot'],
      ['🦝', 'raccoon'],
      ['🦞', 'lobster'],
      ['🦟', 'mosquito'],
      ['🦠', 'microbe'],
      ['🦡', 'badger'],
      ['🦢', 'swan'],
      ['🦣', 'mammoth'],
      ['🦤', 'dodo'],
      ['🦥', 'sloth'],
      ['🦦', 'otter'],
      ['🦧', 'orangutan'],
      ['🦨', 'skunk'],
      ['🦩', 'flamingo'],
      ['🦪', 'oyster'],
      ['🦫', 'beaver'],
      ['🦬', 'bison'],
      ['🦭', 'seal'],
      ['🦮', 'guide chien dog'],
      ['🌰', 'chestnut'],
      ['🌱', 'pousse plante seedling'],
      ['🌲', 'evergreen arbre tree'],
      ['🌳', 'deciduous arbre tree'],
      ['🌴', 'palm arbre tree'],
      ['🌵', 'cactus'],
      ['🌶', 'chaud piment poivron hot pepper'],
      ['🌷', 'tulipe tulip'],
      ['🌸', 'cerise fleur cherry blossom'],
      ['🌹', 'rose'],
      ['🌺', 'hibiscus'],
      ['🌻', 'sunflower'],
      ['🌼', 'fleur blossom'],
      ['🌽', 'ear maize'],
      ['🌾', 'ear riz rice'],
      ['🌿', 'herb'],
      ['🍀', 'quatre feuille trefle chance four leaf clover'],
      ['🍁', 'maple feuille leaf'],
      ['🍂', 'fallen feuille leaf'],
      ['🍃', 'feuille fluttering in wind leaf'],
      ['🍄', 'champignon mushroom'],
    ],
  },
  {
    nom: t.composants.emojis.nourriture,
    onglet: '🍕',
    signes: [
      ['🍅', 'tomate tomato'],
      ['🍆', 'aubergine'],
      ['🍇', 'raisin grapes'],
      ['🍈', 'melon'],
      ['🍉', 'pasteque watermelon'],
      ['🍊', 'tangerine'],
      ['🍋', 'citron lemon'],
      ['🍌', 'banane banana'],
      ['🍍', 'ananas pineapple'],
      ['🍎', 'red pomme apple'],
      ['🍏', 'green pomme apple'],
      ['🍐', 'pear'],
      ['🍑', 'peche peach'],
      ['🍒', 'cerises cherries'],
      ['🍓', 'fraise strawberry'],
      ['🍔', 'burger hamburger'],
      ['🍕', 'slice pizza'],
      ['🍖', 'viande on bone meat'],
      ['🍗', 'poultry leg'],
      ['🍘', 'riz cracker rice'],
      ['🍙', 'riz ballon balle rice ball'],
      ['🍚', 'cooked riz rice'],
      ['🍛', 'curry riz rice'],
      ['🍜', 'steaming bowl'],
      ['🍝', 'pates spaghetti'],
      ['🍞', 'pain bread'],
      ['🍟', 'french frites fries'],
      ['🍠', 'roasted sweet pomme terre potato'],
      ['🍡', 'dango'],
      ['🍢', 'oden'],
      ['🍣', 'sushi'],
      ['🍤', 'fried crevette shrimp'],
      ['🍥', 'poisson gateau swirl design fish cake'],
      ['🍦', 'soft glace creme ice cream'],
      ['🍧', 'shaved glace ice'],
      ['🍨', 'glace creme ice cream'],
      ['🍩', 'beignet donut doughnut'],
      ['🍪', 'biscuit cookie'],
      ['🍫', 'chocolat bar chocolate'],
      ['🍬', 'bonbon candy'],
      ['🍭', 'sucette lollipop'],
      ['🍮', 'custard'],
      ['🍯', 'miel pot honey'],
      ['🍰', 'shortcake'],
      ['🍱', 'bento box'],
      ['🍲', 'pot food'],
      ['🍳', 'cooking'],
      ['🍴', 'fork knife'],
      ['🍵', 'teacup without handle'],
      ['🍶', 'sake bottle cup'],
      ['🍷', 'vin glass wine'],
      ['🍸', 'cocktail glass'],
      ['🍹', 'tropical drink'],
      ['🍺', 'biere mug beer'],
      ['🍻', 'clinking biere mugs beer'],
      ['🍼', 'baby bottle'],
      ['🍽', 'fork knife plate'],
      ['🍾', 'bottle popping cork'],
      ['🍿', 'popcorn'],
      ['🥐', 'croissant'],
      ['🥑', 'avocat avocado'],
      ['🥒', 'cucumber'],
      ['🥓', 'bacon'],
      ['🥔', 'pomme terre potato'],
      ['🥕', 'carotte carrot'],
      ['🥖', 'baguette pain bread'],
      ['🥗', 'green salade salad'],
      ['🥘', 'shallow pan food'],
      ['🥙', 'stuffed flatbread'],
      ['🥚', 'oeuf egg'],
      ['🥛', 'glass milk'],
      ['🥜', 'peanuts'],
      ['🥝', 'kiwifruit'],
      ['🥞', 'pancakes'],
      ['🥟', 'dumpling'],
      ['🥠', 'fortune biscuit cookie'],
      ['🥡', 'takeout box'],
      ['🥢', 'chopsticks'],
      ['🥣', 'bowl spoon'],
      ['🥤', 'cup straw'],
      ['🥥', 'noix coco coconut'],
      ['🥦', 'broccoli'],
      ['🥧', 'pie'],
      ['🥨', 'pretzel'],
      ['🥩', 'cut viande meat'],
      ['🥪', 'sandwich'],
      ['🥫', 'canned food'],
      ['🥬', 'leafy green'],
      ['🥭', 'mango'],
      ['🥮', 'lune gateau moon cake'],
      ['🥯', 'bagel'],
      ['🌭', 'chaud chien hot dog'],
      ['🌮', 'taco'],
      ['🌯', 'burrito'],
    ],
  },
  {
    nom: t.composants.emojis.sports,
    onglet: '⚽',
    signes: [
      ['🎠', 'carousel cheval horse'],
      ['🎡', 'ferris wheel'],
      ['🎢', 'roller coaster'],
      ['🎣', 'fishing pole poisson fish'],
      ['🎤', 'micro microphone'],
      ['🎥', 'movie appareil photo camera'],
      ['🎦', 'cinema'],
      ['🎧', 'casque headphone'],
      ['🎨', 'artist palette'],
      ['🎩', 'top hat'],
      ['🎪', 'circus tente tent'],
      ['🎫', 'ticket'],
      ['🎬', 'clapper board'],
      ['🎭', 'performing arts'],
      ['🎮', 'video jeu game'],
      ['🎯', 'direct hit'],
      ['🎰', 'slot machine'],
      ['🎱', 'billiards'],
      ['🎲', 'jeu de game die'],
      ['🎳', 'bowling'],
      ['🎴', 'fleur playing cards flower'],
      ['🎵', 'musique note musical'],
      ['🎶', 'multiple musique notes musical'],
      ['🎷', 'saxophone'],
      ['🎸', 'guitare guitar'],
      ['🎹', 'musique keyboard musical'],
      ['🎺', 'trumpet'],
      ['🎻', 'violin'],
      ['🎼', 'musique score musical'],
      ['🎽', 'running shirt sash'],
      ['🎾', 'tennis racquet ballon balle ball'],
      ['🎿', 'ski boot'],
      ['🏀', 'basket hoop basketball'],
      ['🏁', 'chequered flag'],
      ['🏂', 'snowboarder'],
      ['🏃', 'runner'],
      ['🏄', 'surfer'],
      ['🏅', 'sports medaille medal'],
      ['🏆', 'trophee coupe trophy'],
      ['🏇', 'cheval racing horse'],
      ['🏈', 'american foot football'],
      ['🏉', 'rugby foot football'],
      ['🏏', 'cricket chauve souris ballon balle bat ball'],
      ['🏐', 'volleyball'],
      ['🏑', 'field hockey stick ballon balle ball'],
      ['🏒', 'glace hockey stick puck ice'],
      ['🏓', 'table tennis paddle ballon balle ball'],
      ['⚽', 'foot football ballon balle soccer ball'],
      ['⚾', 'baseball'],
      ['🥅', 'goal net'],
      ['🥇', 'first place medaille medal'],
      ['🥈', 'second place medaille medal'],
      ['🥉', 'third place medaille medal'],
      ['🥊', 'boxing glove'],
      ['🥋', 'martial arts uniform'],
      ['🥌', 'curling stone'],
    ],
  },
  {
    nom: t.composants.emojis.voyages,
    onglet: '✈️',
    signes: [
      ['🚀', 'fusee rocket'],
      ['🚁', 'helicoptere helicopter'],
      ['🚂', 'steam locomotive'],
      ['🚃', 'railway voiture car'],
      ['🚄', 'high speed train high-speed'],
      ['🚅', 'high speed train bullet nose high-speed'],
      ['🚆', 'train'],
      ['🚇', 'metro'],
      ['🚈', 'lumiere rail light'],
      ['🚉', 'station'],
      ['🚊', 'tram'],
      ['🚋', 'tram voiture car'],
      ['🚌', 'bus'],
      ['🚍', 'oncoming bus'],
      ['🚎', 'trolleybus'],
      ['🚏', 'bus stop'],
      ['🚐', 'minibus'],
      ['🚑', 'ambulance'],
      ['🚒', 'feu engine fire'],
      ['🚓', 'police voiture car'],
      ['🚔', 'oncoming police voiture car'],
      ['🚕', 'taxi'],
      ['🚖', 'oncoming taxi'],
      ['🚗', 'automobile'],
      ['🚘', 'oncoming automobile'],
      ['🚙', 'recreational vehicle'],
      ['🚚', 'delivery camion truck'],
      ['🚛', 'articulated lorry'],
      ['🚜', 'tractor'],
      ['🚝', 'monorail'],
      ['🚞', 'montagne railway mountain'],
      ['🚟', 'suspension railway'],
      ['🚠', 'montagne cableway mountain'],
      ['🚡', 'aerial tramway'],
      ['🚢', 'bateau ship'],
      ['🚣', 'rowboat'],
      ['🚤', 'speedboat'],
      ['🌍', 'terre monde europe africa earth globe europe-africa'],
      ['🌎', 'terre monde americas earth globe'],
      ['🌏', 'terre monde asia australia earth globe asia-australia'],
      ['🌐', 'terre monde meridians globe'],
      ['🌑', 'new lune signe moon'],
      ['🌒', 'waxing crescent lune signe moon'],
      ['🌓', 'first quarter lune signe moon'],
      ['🌔', 'waxing gibbous lune signe moon'],
      ['🌕', 'full lune signe moon'],
      ['🌖', 'waning gibbous lune signe moon'],
      ['🌗', 'last quarter lune signe moon'],
      ['🌘', 'waning crescent lune signe moon'],
      ['🌙', 'crescent lune moon'],
      ['🌚', 'new lune visage tete moon face'],
      ['🌛', 'first quarter lune visage tete moon face'],
      ['🌜', 'last quarter lune visage tete moon face'],
      ['🌝', 'full lune visage tete moon face'],
      ['🌞', 'soleil visage tete sun face'],
      ['🌟', 'glowing etoile star'],
      ['🌠', 'shooting etoile star'],
      ['🏔', 'neige capped montagne snow mountain'],
      ['🏕', 'camping'],
      ['🏖', 'plage umbrella beach'],
      ['🏗', 'immeuble construction building'],
      ['🏘', 'maison buildings house'],
      ['🏙', 'cityscape'],
      ['🏚', 'derelict maison immeuble house building'],
      ['🏛', 'classical immeuble building'],
      ['🏜', 'desert'],
      ['🏝', 'desert ile island'],
      ['🏞', 'national park'],
      ['🏟', 'stadium'],
      ['🏠', 'maison immeuble house building'],
      ['🏡', 'maison garden house'],
    ],
  },
  {
    nom: t.composants.emojis.objets,
    onglet: '💡',
    signes: [
      ['💠', 'diamond shape a dot inside'],
      ['💡', 'electric lumiere ampoule idee light bulb'],
      ['💢', 'anger signe'],
      ['💣', 'bombe bomb'],
      ['💤', 'dort dormir signe sleeping'],
      ['💥', 'explosion boum signe collision'],
      ['💦', 'splashing sueur transpire signe sweat'],
      ['💧', 'droplet'],
      ['💨', 'dash signe'],
      ['💩', 'pile poo'],
      ['💪', 'muscle force flexed biceps'],
      ['💫', 'etourdi signe dizzy'],
      ['💬', 'parole bulle ballon speech balloon'],
      ['💭', 'pensee ballon thought balloon'],
      ['💮', 'white fleur flower'],
      ['💯', 'cent points signe hundred'],
      ['💰', 'argent bag money'],
      ['💱', 'currency exchange'],
      ['💲', 'heavy dollar argent signe'],
      ['💳', 'carte credit card'],
      ['💴', 'billet argent yen signe banknote'],
      ['💵', 'billet argent dollar signe banknote'],
      ['💶', 'billet argent euro signe banknote'],
      ['💷', 'billet argent pound signe banknote'],
      ['💸', 'argent wings money'],
      ['💹', 'chart upwards trend yen signe'],
      ['💺', 'seat'],
      ['💻', 'personal ordinateur computer'],
      ['💼', 'briefcase'],
      ['💽', 'minidisc'],
      ['💾', 'floppy disk'],
      ['💿', 'optical disc'],
      ['📀', 'dvd'],
      ['📁', 'file folder'],
      ['📂', 'ouvert file folder open'],
      ['📃', 'page curl'],
      ['📄', 'page facing haut up'],
      ['📅', 'calendar'],
      ['📆', 'tear off calendar tear-off'],
      ['📇', 'carte index card'],
      ['📈', 'chart upwards trend'],
      ['📉', 'chart downwards trend'],
      ['📊', 'bar chart'],
      ['📋', 'clipboard'],
      ['📌', 'pushpin'],
      ['📍', 'round pushpin'],
      ['📎', 'paperclip'],
      ['📏', 'straight ruler'],
      ['📐', 'triangular ruler'],
      ['📑', 'bookmark tabs'],
      ['📒', 'ledger'],
      ['📓', 'notebook'],
      ['📔', 'notebook decorative cover'],
      ['📕', 'ferme livre closed book'],
      ['📖', 'ouvert livre open book'],
      ['📗', 'green livre book'],
      ['📘', 'blue livre book'],
      ['📙', 'orange livre book'],
      ['📚', 'books'],
      ['📛', 'name badge'],
      ['📜', 'scroll'],
      ['📝', 'memo'],
      ['📞', 'telephone receiver'],
      ['📟', 'pager'],
      ['📠', 'fax machine'],
      ['📡', 'satellite antenna'],
      ['📢', 'public address loudspeaker'],
      ['📣', 'cheering megaphone'],
      ['📤', 'outbox tray'],
      ['📥', 'inbox tray'],
      ['📦', 'package'],
      ['📧', 'e mail signe e-mail'],
      ['📨', 'incoming envelope'],
      ['📩', 'envelope downwards arrow above'],
      ['📪', 'ferme mailbox lowered flag closed'],
      ['📫', 'ferme mailbox leve flag closed raised'],
      ['📬', 'ouvert mailbox leve flag open raised'],
      ['📭', 'ouvert mailbox lowered flag open'],
      ['📮', 'postbox'],
      ['📯', 'postal horn'],
      ['📰', 'newspaper'],
      ['📱', 'telephone mobile phone'],
      ['📲', 'telephone rightwards arrow at gauche mobile phone left'],
      ['📳', 'vibration mode'],
      ['📴', 'telephone off mobile phone'],
      ['📵', 'no telephone phones mobile'],
      ['📶', 'antenna bars'],
      ['📷', 'appareil photo camera'],
      ['📸', 'appareil photo flash camera'],
      ['📹', 'video appareil photo camera'],
      ['📺', 'television'],
      ['📻', 'radio'],
      ['📼', 'videocassette'],
      ['📽', 'film projector'],
      ['📿', 'prayer beads'],
      ['🔀', 'twisted rightwards arrows'],
      ['🔁', 'clockwise rightwards leftwards ouvert circle arrows open'],
      ['🔂', 'clockwise rightwards leftwards ouvert circle arrows circled one overlay open'],
      ['🔃', 'clockwise downwards upwards ouvert circle arrows open'],
      ['🔄', 'anticlockwise downwards upwards ouvert circle arrows open'],
      ['🔅', 'low brightness signe'],
      ['🔆', 'high brightness signe'],
      ['🔇', 'speaker cancellation stroke'],
      ['🔈', 'speaker'],
      ['🔉', 'speaker one sound wave'],
      ['🔊', 'speaker three sound waves'],
      ['🔋', 'battery'],
      ['🔌', 'electric plug'],
      ['🔍', 'gauche pointe montre magnifying glass left-pointing'],
      ['🔎', 'droite pointe montre magnifying glass right-pointing'],
      ['🔏', 'cadenas ink stylo lock pen'],
      ['🔐', 'ferme cadenas cle closed lock key'],
      ['🔑', 'cle key'],
      ['🔒', 'cadenas lock'],
      ['🔓', 'ouvert cadenas open lock'],
      ['🔔', 'cloche bell'],
      ['🔕', 'cloche cancellation stroke bell'],
      ['🔖', 'bookmark'],
      ['🔗', 'link signe'],
      ['🔘', 'radio button'],
      ['🔙', 'back leftwards arrow above'],
      ['🔚', 'end leftwards arrow above'],
      ['🔛', 'on exclamation signe gauche droite arrow above mark left right'],
      ['🔜', 'soon rightwards arrow above'],
      ['🔝', 'top upwards arrow above'],
      ['🔞', 'no one under eighteen signe'],
      ['🔟', 'keycap ten'],
      ['🔠', 'input signe for latin capital letters'],
      ['🔡', 'input signe for latin small letters'],
      ['🔢', 'input signe for numbers'],
      ['🔣', 'input signe for symbols'],
      ['🔤', 'input signe for latin letters'],
      ['🔥', 'feu fire'],
      ['🔦', 'electric torch'],
      ['🔧', 'wrench'],
      ['🔨', 'hammer'],
      ['🔩', 'nut bolt'],
      ['🔪', 'hocho'],
      ['🔫', 'pistol'],
      ['🔬', 'microscope'],
      ['🔭', 'telescope'],
      ['🔮', 'crystal ballon balle ball'],
      ['🔯', 'six pointed etoile milieu dot star middle'],
      ['🔰', 'japanese signe for beginner'],
      ['🔱', 'trident emblem'],
      ['🔲', 'black square button'],
      ['🔳', 'white square button'],
      ['🔴', 'large red circle'],
      ['🔵', 'large blue circle'],
      ['🔶', 'large orange diamond'],
      ['🔷', 'large blue diamond'],
      ['🔸', 'small orange diamond'],
      ['🔹', 'small blue diamond'],
      ['🔺', 'haut pointe montre red triangle up-pointing'],
      ['🔻', 'bas pointe montre red triangle down-pointing'],
      ['🔼', 'haut pointe montre small red triangle up-pointing'],
      ['🔽', 'bas pointe montre small red triangle down-pointing'],
      ['🧰', 'toolbox'],
      ['🧱', 'brick'],
      ['🧲', 'magnet'],
      ['🧳', 'luggage'],
      ['🧴', 'lotion bottle'],
      ['🧵', 'spool thread'],
      ['🧶', 'ballon balle yarn ball'],
      ['🧷', 'safety pin'],
      ['🧸', 'teddy ours bear'],
      ['🧹', 'broom'],
      ['🧺', 'basket'],
      ['🧻', 'roll paper'],
      ['🧼', 'bar soap'],
      ['🧽', 'sponge'],
      ['🧾', 'receipt'],
      ['🧿', 'nazar amulet'],
    ],
  },
  {
    nom: t.composants.emojis.symboles,
    onglet: '❗',
    signes: [
      ['💯', 'cent points signe hundred'],
      ['✨', 'etincelles brillant sparkles'],
      ['🔥', 'feu fire'],
      ['✅', 'white heavy coche valide signe check mark'],
      ['❌', 'croix signe cross mark'],
      ['❓', 'black question signe ornament mark'],
      ['❔', 'white question signe ornament mark'],
      ['❕', 'white exclamation signe ornament mark'],
      ['❗', 'heavy exclamation signe mark'],
      ['🆕', 'squared new'],
      ['🆖', 'squared ng'],
      ['🆗', 'squared ok'],
      ['🆘', 'squared sos'],
      ['🆙', 'squared haut exclamation signe up mark'],
      ['🆚', 'squared vs'],
      ['🔟', 'keycap ten'],
    ],
  },
];
